<template>
  <div
    class="nav_crumbs_container nav_crumbs_container--simple"
    v-if="crumbProp.type === 'simple'"
  >
    {{ $t(crumbProp.label) }}
  </div>
  <div class="nav_crumbs_container nav_crumbs_container--drawer" v-else>
    <ul class="nav_crumbs_body" v-show="isPc">
      <li
        class="nav_crumbs-item"
        v-for="(crumbItem, crumbIdx) in crumbProp.crumbList"
        :key="crumbIdx"
      >
        <div @click="navTo(crumbItem.routeName)" class="nav_crumbs-item_body">
          {{ crumbItem.label }}
        </div>
        <img
          src="../assets/img/forword.png"
          class="arrow_right"
          v-if="crumbIdx < crumbProp.crumbList.length - 1"
        />
      </li>
    </ul>
    <div v-show="!isPc" class="back_titile" @click="viewFaqPage">Back</div>
  </div>
</template>

<script>
export default {
  name: "NewsMenu",
  props: {
    crumbProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    viewFaqPage() {
      this.$router.push({
        name: "faq",
      });
    },
    navTo(navURL) {
      console.log(navURL);
      if (navURL == "faq") {
        this.$router.push({ name: "faq" });
      } else {
        this.$router.push({ path: navURL });
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .leftMenu {
       display none
    }
    .back_titile{
        font-size: 16px;
        color: #4378f2;
        padding: 0 5%;
    }
}
@media only screen and (min-width: 701px) {
    .nav_crumbs_container {
        letter-spacing 1px;
        font-weight:300;
       display: flex;
       align-items: center;
       height: 82px;
       width: 800px;
       margin: 0 auto;
       color: #275edb;
       font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
       font-size: 24px;
       line-height: 34px;
       border-bottom: solid 1px #efeff4;
       // margin-top:20px;
       .nav_crumbs_body{
           display flex;
           justify-content center;
           .nav_crumbs-item{
               display: flex;
               align-items: center;
               color: #808080;
               font-size: 15px;
               line-height: 34px;
               .nav_crumbs-item_body{
                   cursor pointer;
                   margin-right: 13px;
                   font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                   font-size: 15px;
               }
           }
           .arrow_right{
               width: 14px;
               height: 14px;
               margin-right: 13px;
           }
           .nav_crumbs-item:nth-last-child(1) {
               color: #000;
               font-size: 15px;
               line-height: 34px;
           }
       }
   }
}
</style>
